"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var AdminDocumentsController = /** @class */ (function () {
    function AdminDocumentsController($state, $scope, FlashService, $window, DocumentInstanceModel) {
        this.$state = $state;
        this.$scope = $scope;
        this.FlashService = FlashService;
        this.$window = $window;
        this.DocumentInstanceModel = DocumentInstanceModel;
        this.documents = [];
        this.loading = false;
        this.currentPage = 1;
        this.totalPages = 1;
        this.perPage = 20;
        this.searchTerm = "";
        this.statusFilter = "all";
        this.loadDocuments();
    }
    AdminDocumentsController.prototype.loadDocuments = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        params = {
                            page: this.currentPage,
                            per_page: this.perPage,
                        };
                        if (this.searchTerm) {
                            params.search = this.searchTerm;
                        }
                        if (this.statusFilter !== "all") {
                            params.status = this.statusFilter;
                        }
                        return [4 /*yield*/, this.DocumentInstanceModel.getDocuments(params)];
                    case 2:
                        response = _a.sent();
                        this.documents = response.data || [];
                        this.totalPages = response.last_page || 1;
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        this.FlashService.setMessage({
                            type: "error",
                            message: "Failed to load documents",
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        this.$scope.$applyAsync();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AdminDocumentsController.prototype.viewDocument = function (instance) {
        this.$state.go("drivecoach.admin.documentinstance", { id: instance.id });
    };
    AdminDocumentsController.prototype.archiveDocument = function (instance) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!confirm("Are you sure you want to archive this document?")) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, this.DocumentInstanceModel.archiveDocument(instance.id)];
                    case 2:
                        _a.sent();
                        this.FlashService.setMessage({
                            type: "success",
                            message: "Document archived successfully",
                        });
                        return [4 /*yield*/, this.loadDocuments()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        error_2 = _a.sent();
                        this.FlashService.setMessage({
                            type: "error",
                            message: "Failed to archive document",
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        this.$scope.$applyAsync();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AdminDocumentsController.prototype.sendReminder = function (instance) {
        return __awaiter(this, void 0, void 0, function () {
            var pendingUsers, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        pendingUsers = instance.assigned_users
                            .filter(function (a) { return a.completion_status !== "completed"; })
                            .map(function (a) { return a.user_id; });
                        if (pendingUsers.length === 0) {
                            this.FlashService.setMessage({
                                type: "info",
                                message: "No pending users to remind",
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.DocumentInstanceModel.sendReminder(instance.id, {
                                user_ids: pendingUsers,
                                message: "Please complete your assigned fields in the document.",
                            })];
                    case 1:
                        _a.sent();
                        this.FlashService.setMessage({
                            type: "success",
                            message: "Reminders sent successfully",
                        });
                        return [3 /*break*/, 4];
                    case 2:
                        error_3 = _a.sent();
                        console.error(error_3);
                        this.FlashService.setMessage({
                            type: "error",
                            message: "Failed to send reminders",
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        this.$scope.$applyAsync();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AdminDocumentsController.prototype.search = function () {
        this.currentPage = 1;
        this.loadDocuments();
    };
    AdminDocumentsController.prototype.nextPage = function () {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
            this.loadDocuments();
        }
    };
    AdminDocumentsController.prototype.previousPage = function () {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.loadDocuments();
        }
    };
    AdminDocumentsController.prototype.getStatusClass = function (status) {
        var classes = {
            pending: "label-warning",
            in_progress: "label-info",
            completed: "label-success",
            archived: "label-default",
        };
        return classes[status] || "label-default";
    };
    AdminDocumentsController.prototype.getStatusLabel = function (status) {
        var labels = {
            pending: "Pending",
            in_progress: "In Progress",
            completed: "Completed",
            archived: "Archived",
        };
        return labels[status] || status;
    };
    return AdminDocumentsController;
}());
AdminDocumentsController.$inject = [
    "$state",
    "$scope",
    "FlashService",
    "$window",
    "DocumentInstanceModel",
];
exports.default = AdminDocumentsController;
